<template lang="html">

  <section class="wrapper wrapper-view">

    <nav class="breadcrumb container">
      <router-link to="/">Home</router-link>
      <router-link :to="$t('enlaces.contacto')">Contacto</router-link>
    </nav>

    <div class="intro-contacto container">
      <h2>¿Tienes dudas? Contáctanos</h2>
      <div class="links row-center">
        <a href="tel:917091414" class="phone">917091414</a>
        <a href="https://ufv-es.instructure.com/login/canvas" target="_blank">Contacta con nosotros</a>
      </div>
    </div>

    <div class="contenedor-formulario-contacto">

      <formulario></formulario>

    </div>

  </section>

</template>

<script lang="js">

  import formulario from '@/components/view-parts/contacto/formulario'

  export default {
    name: 'contacto',
    components: {
      formulario
    }
  }
</script>

<style scoped lang="scss">
  .contacto {}
</style>


// WEBPACK FOOTER //
// src/components/views/contacto.vue